(function () {
  const block = {
    $blocks: document.querySelectorAll('section.ndc_hero_block'),
    init() {
      if (this.$blocks.length) {
        this.processBlocks();
        this.setUpEventListeners();
      }
    },

    processBlocks() {
      this.$blocks.forEach($block => {
        if ($block.classList.contains('template_breadcrumbs')) {
          const $quicklinksMenu = $block.querySelector('.quicklinks_menu');
          const $menu = $block.querySelector('.menu');

          if ($quicklinksMenu
          && (
            $quicklinksMenu.classList.contains('template_h2')
            || $quicklinksMenu.classList.contains('template_h3')
            || $quicklinksMenu.classList.contains('template_h4')
          )) {
            const selectedHeadingLevel = $quicklinksMenu.dataset.headingLevel;
            const $headings = document.querySelectorAll(`#main ${selectedHeadingLevel}`);

            $headings.forEach($heading => {
              // make sure the heading is not a child of this block
              if (!$heading.closest('.ndc_hero_block')) {
                let $link;

                if ($heading.id) {
                  $link = document.createElement('a');
                  $link.href = `#${$heading.id}`;
                } else {
                  $link = document.createElement('span');
                }

                $link.classList.add('item');
                $link.textContent = $heading.textContent;
                $link.$heading = $heading;

                $menu.appendChild($link);
              }
            });
          } else if ($quicklinksMenu && $quicklinksMenu.classList.contains('template_manual')) {
            $quicklinksMenu
              .querySelectorAll('.item')
              .forEach($item => {
                const itemHref = $item.getAttribute('href');

                if (itemHref && itemHref !== '#') {
                  const $heading = document.querySelector(itemHref);

                  if ($heading) {
                    $item.$heading = $heading;
                  } else {
                    $item.classList.add('disabled');
                  }
                } else {
                  $item.classList.add('disabled');
                }
              });
          }
        }
      });
    },

    setUpEventListeners() {
    }
  };

  block.init();
})();